<footer (window:resize)="onResize()">
	<section class="bar-item">
		<div [style.width.%]="previousPercentage" class="previous-progress"></div>
		<div [style.width.%]="percentage">
			<div class="progress"></div>
		</div>
	</section>
	<section class="progress-bar-container">
		<div
			*ngIf="!this.isMobile"
			class="progress-bar-content zk-flex zk-justify-between zk-items-center"
		>
			<freud-button
				[disabled]="isFirstStep()"
				color="secondary"
				(click)="onBackClick(isFirstStep())"
				size="md"
			>
				Voltar
			</freud-button>

			<div id="steps-count" class="zk-flex zk-justify-center step-number">
				{{ currentStepId }} de {{ steps.length }}
			</div>

			<freud-button
				[disabled]="!this.btnActive"
				*ngIf="!isLastStep"
				(click)="onNextClick(!this.btnActive)"
				size="md"
			>
				Continuar
			</freud-button>
			<freud-button *ngIf="isLastStep" size="md">
				Confirmar pagamento
			</freud-button>
		</div>

		<div
			*ngIf="this.isMobile"
			class="
				progress-bar-content
				zk-flex zk-justify-between zk-items-center
				mobile
			"
		>
			<freud-button
				[disabled]="isFirstStep()"
				color="secondary"
				(click)="onBackClick(isFirstStep())"
				size="md"
			>
				<span class="freud-icon freud-icon-chevron-left freud-icon-md"></span>
			</freud-button>

			<div class="zk-flex zk-justify-center step-number">
				{{ currentStepId }} de {{ steps.length }}
			</div>

			<freud-button
				[disabled]="!this.btnActive"
				*ngIf="!isLastStep"
				(click)="onNextClick(!this.btnActive)"
				size="md"
			>
				<span class="freud-icon freud-icon-chevron-right freud-icon-md"></span>
			</freud-button>
			<freud-button *ngIf="isLastStep" size="md">
				<span class="freud-icon freud-icon-chevron-right freud-icon-md"></span>
			</freud-button>
		</div>
	</section>
</footer>
